/* eslint @typescript-eslint/strict-boolean-expressions: off */

import Link from "next/link";
import styles from "gui/projects/projects.module.css";
import { Cell } from "gui/grid/cell";
import { createProjectTheme } from "pages/projects/[slug]";
import { Grid } from "gui/grid/grid";
import { Icon } from "gui/icon/icon";
import { Project } from "lib/projects/types";
import { ProjectLogo } from "gui/project/project";
import { SanityProjects } from "lib/sanity/types";
import { Subtitle } from "gui/subtitle/subtitle";

export const Projects: React.FC<{
  item: SanityProjects;
}> = (props) => {
  if (!props.item.projects?.length) {
    return null;
  }

  return (
    <Grid revealOnScroll gaps>
      {props.item.title && (
        <Subtitle text={props.item.title} icon={props.item.icon}>
          {props.item.link && props.item.more && (
            <a href={props.item.link}>
              {props.item.more}
              <Icon icon="arrow-right" />
            </a>
          )}
        </Subtitle>
      )}
      <Cell as="ul" className={styles.list}>
        {props.item.projects.map((project) => (
          <li
            key={project.id}
            className={styles.item}
            style={createProjectTheme(project)}
          >
            <ProjectsLogo project={project} />
          </li>
        ))}
      </Cell>
    </Grid>
  );
};

const ProjectsLogo: React.FC<{
  project: Project;
}> = (props) => {
  return (
    <Link href="/projects/[slug]" as={`/projects/${props.project.id}`}>
      <a className={styles.logo}>
        <ProjectLogo project={props.project} />
      </a>
    </Link>
  );
};
